module.exports = __webpack_public_path__ + "media/images/games/k2reveal/camel-437f4eb3c65169b8def27545dec36384.png";